import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Type, Stack, Card } from 'react-spark';
import { formatMoney } from '../../../../utils/numbers';
import { FilterSliderIcon, SpecialOfferIcon } from '../../icons';
import { OffersV3NotificationBanner } from './OffersV3NotificationBanner';
import { FONT_SIZES } from '../../../../utils/novaTypography';

export class OffersV3Header extends Component {
    static propTypes = {
        firstName: PropTypes.string.isRequired,
        maxOffer: PropTypes.number.isRequired,
        minOffer: PropTypes.number.isRequired,
        selectedOffer: PropTypes.number,
        counterOffer: PropTypes.bool,
        counterOfferReportChanged: PropTypes.bool,
        onAdjustAmountClick: PropTypes.func,
    };

    static defaultProps = {
        counterOffer: false,
        counterOfferReportChanged: false,
        firstName: '',
        selectedOffer: null,
        onAdjustAmountClick: () => {},
    };

    handleAdjustAmountClick = () => {
        this.props.onAdjustAmountClick();
    };

    render() {
        const { firstName, maxOffer, minOffer, selectedOffer, counterOffer, counterOfferReportChanged } = this.props;

        const displayAmount = selectedOffer || maxOffer;
        const isShowingMaxOffer = !selectedOffer || selectedOffer === maxOffer;
        const hasSingleAmount = maxOffer === minOffer;
        const showMaxOfferLanguage = isShowingMaxOffer && !hasSingleAmount;

        return (
            <Fragment>
                <Stack className="offers-v3-header sprk-u-ptm@l">
                    <Type.DisplayFour className="offers-v3-header__title sprk-u-pbl sprk-u-mvl" style={{ fontSize: FONT_SIZES.title, lineHeight: 1.22 }}>
                        {firstName}, you're prequalified for{showMaxOfferLanguage ? ' up to' : ''} {formatMoney(displayAmount)}!*
                    </Type.DisplayFour>

                    {counterOffer && (
                        <OffersV3NotificationBanner
                            title="Please select a new offer."
                            message="Your application details have changed, so your original offer is no longer available."
                        />
                    )}

                    {counterOfferReportChanged && (
                        <OffersV3NotificationBanner
                            title="Your loan terms have changed. Please select a new offer."
                            message="Your credit profile showed a change from the initial soft credit inquiry that was used to generate your loan offers."
                        />
                    )}

                    <Card className="offers-v3-card sprk-u-Position--relative">
                        <Card.Content>
                            <SpecialOfferIcon width={52} height={56} className="offers-v3-header__special-offer-icon sprk-u-Position--absolute" />
                            <Type.BodyFour className={`offers-v3-header__card-label sprk-u-Position--absolute ${showMaxOfferLanguage ? 'offers-v3-header__card-label--max-offer' : 'offers-v3-header__card-label--regular-offer'
                                }`}>
                                {showMaxOfferLanguage ? 'Your max offer' : 'Your loan offer'}
                            </Type.BodyFour>

                            <Type.DisplayFour className="offers-v3-header__amount sprk-u-AbsoluteCenter sprk-u-mts sprk-u-MarginBottom--a" style={{ fontSize: FONT_SIZES.hero }}>
                                {formatMoney(displayAmount)}
                            </Type.DisplayFour>

                            {!hasSingleAmount && (
                                <Fragment>
                                    <span className='sprk-c-Divider sprk-u-MarginBottom--a sprk-u-mtn' style={{ borderBottom: '1px solid #E9E9E9' }}></span>
                                    <button
                                        id="offers-adjust-amount"
                                        className="offers-v3-header__adjust-link sprk-u-AbsoluteCenter"
                                        onClick={this.handleAdjustAmountClick}
                                    >
                                        Adjust amount
                                        <FilterSliderIcon style={{
                                            height: '24px',
                                            width: '24px',
                                            marginLeft: '4px'
                                        }} />
                                    </button>
                                </Fragment>
                            )}
                        </Card.Content>
                    </Card>
                </Stack>
            </Fragment>
        );
    }
}
